// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.dashboard_customSidebar__lrdY8 {
  background: linear-gradient(175deg, var(--secondary) 0%, var(--secondary) 30%, var(--primary) 100%);
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 9999;
  overflow-y: auto;
  min-width: 200px;
  max-width: 300px;
}

.dashboard_customSidebar__lrdY8.dashboard_active__UkmNb {
  transform: translateX(0%);
}

.dashboard_customSidebar__lrdY8 .dashboard_sidebarHead__GObQC {
  display: flex;
  justify-content: space-between;
  padding: 15px;
}

.dashboard_customSidebar__lrdY8 .dashboard_sidebarHead__GObQC img {
  height: 40px;
  width: 100%;
  object-fit: contain;
}

.dashboard_customSidebar__lrdY8 hr {
  background-image: linear-gradient(90deg, rgba(46, 46, 144, 0) 0%, white 49.72%, rgba(46, 46, 144, 0) 101.55%);
  height: 1px;
  opacity: 1;
  border: 0;
  margin: 0;
}

/* Sidebar Menu */
.dashboard_sidebarMenu__CD2jt {
  margin-top: 70px;
  height: 65vh;
  overflow-y: scroll;
}

.dashboard_sidebarMenu__CD2jt::-webkit-scrollbar {
  width: 0;
}

.dashboard_menuItem__8\\+HgP {
  position: relative;
  z-index: 99;
}

.dashboard_menuItem__8\\+HgP a,
.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button {
  padding: 10px 0 10px 30px;
  margin-bottom: 10px;
  color: white;
  font-weight: 600;
  display: block;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.5s ease;
}

.dashboard_menuItem__8\\+HgP a svg,
.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button svg {
  font-size: 16px;
}

.dashboard_menuItem__8\\+HgP::before {
  content: '';
  position: absolute;
  top: 0;
  right: -1px;
  width: 0;
  height: 100%;
  background-color: white;
  border-radius: 15px 0 0 15px;
  z-index: -1;
  transition: width 0.5s ease;
}

.dashboard_menuItem__8\\+HgP.dashboard_active__UkmNb::before,
.dashboard_menuItem__8\\+HgP:hover::before {
  width: 100%;
}

.dashboard_menuItem__8\\+HgP.dashboard_active__UkmNb a,
.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP.dashboard_active__UkmNb button,
.dashboard_menuItem__8\\+HgP:hover a,
.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP:hover button {
  color: var(--primary);
}

/* Sidebar Footer */
.dashboard_sidebarFooter__WbIrB {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.dashboard_sidebarFooter__WbIrB span {
  text-align: center;
  padding: 15px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  display: block;
}

.dashboard_sidebarFooter__WbIrB button {
  line-height: 30px;
  color: white !important;
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 15px;
  border: 0;
}

.dashboard_sidebarFooter__WbIrB button svg {
  font-size: 16px;
}

/* Toggle Buttons */
.dashboard_sidebarToggleWrap__Aja58 {
  display: none;
}

.dashboard_sidebarToggleBtn__IgSrx {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  margin: 0;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: var(--primary);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(46, 46, 144, 0.15);
  flex-shrink: 0;
}

.dashboard_sidebarClose__eUuZq {
  display: none;
  cursor: pointer;
  border: 0;
  background: white;
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  font-size: 20px;
  padding: 10px;
  border-radius: 50%;
  z-index: 10001;
  align-items: center;
  justify-content: center;
}

/* Accordion */
.dashboard_sidebarSubMenu__o-YgG ul {
  list-style: none;
  padding: 0;
}

.dashboard_submenuDropdownIcon__KcK0Z svg {
  font-size: 24px !important;
  transition: transform 0.5s ease;
}

.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP {
  background: none;
  border: 0;
}

.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button {
  background: none;
  box-shadow: none;
  border: none;
}

.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button[aria-expanded='true'] .dashboard_submenuDropdownIcon__KcK0Z svg {
  transform: rotate(180deg);
}

.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button::after {
  display: none !important;
}

.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP:has(h2 button[aria-expanded='true']) {
  border-radius: 15px 0 0 15px;
  background-color: white;
}

.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP:has(h2 button[aria-expanded='true']) button,
.dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP:has(h2 button[aria-expanded='true']) a {
  color: #2E2E90;
}

/* Main Content Wrapper */
.dashboard_sidebarContentWrapper__aYsOZ {
  background-color: white;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  position: relative;
}

.dashboard_customBackdrop__hkYdg::before {
  content: '';
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 9998;
}

/* Body No Scroll */
body.dashboard_no-scroll__oXT-Z {
  overflow: hidden;
}

/* Mobile Content */
.dashboard_mobileContentWrapper__gsf-4 {
  min-height: 100vh;
  position: relative;
  background-color: white;
}

.dashboard_mobileContent__g39VN {
  padding: 15px;
}

.dashboard_mobileMenu__90XAP {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0;
}

.dashboard_mobileMenu__90XAP ul {
  display: flex;
  justify-content: space-around;
  padding: 0;
  list-style: none;
  margin: 0;
  background-color: white;
  box-shadow: 10px 8px 10px 5px var(--primary);
  border-radius: 3px 3px 0 0;
}

.dashboard_mobileMenu__90XAP ul li {
  color: var(--primary);
  font-size: 24px;
  flex: 1 1;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 10px 0;
}

.dashboard_mobileMenu__90XAP ul li.dashboard_active__UkmNb {
  box-shadow: 0 0 5px var(--primary);
  font-size: 28px;
  background-color: var(--primary);
  color: white;
  padding: 12px 0;
}

/* Media Queries */
@media (max-width: 1399px) {

  .dashboard_menuItem__8\\+HgP a,
  .dashboard_sidebarFooter__WbIrB button svg,
  .dashboard_sidebarFooter__WbIrB button,
  .dashboard_menuItem__8\\+HgP a svg,
  .dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button,
  .dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button svg {
    font-size: 14px;
  }

  .dashboard_sidebarFooter__WbIrB span {
    font-size: 12px;
  }

  .dashboard_customSidebar__lrdY8 .dashboard_sidebarHead__GObQC img {
    height: 35px;
  }

  .dashboard_menuItem__8\\+HgP a,
  .dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button {
    padding: 10px 0 10px 20px;
  }
}

@media (max-width: 1024px) {

  .dashboard_menuItem__8\\+HgP a,
  .dashboard_sidebarFooter__WbIrB button svg,
  .dashboard_sidebarFooter__WbIrB button,
  .dashboard_menuItem__8\\+HgP a svg,
  .dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button,
  .dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button svg {
    font-size: 12px;
  }

  .dashboard_sidebarFooter__WbIrB span {
    font-size: 10px;
  }
}

@media (max-width: 991px) {
  .dashboard_customSidebar__lrdY8 {
    width: 0;
    min-width: 0;
    max-width: none;
  }

  .dashboard_customSidebar__lrdY8.dashboard_active__UkmNb {
    width: 100%;
    max-width: 100%;
  }

  .dashboard_sidebarToggleWrap__Aja58 {
    display: block;
    padding: 12px 0 8px;
  }

  .dashboard_sidebarClose__eUuZq {
    display: inline-flex;
  }

  .dashboard_sidebarContentWrapper__aYsOZ {
    width: 100%;
  }

  .dashboard_menuItem__8\\+HgP a,
  .dashboard_sidebarFooter__WbIrB button,
  .dashboard_sidebarFooter__WbIrB span,
  .dashboard_sidebarAccordion__18JkA .dashboard_menuItem__8\\+HgP button {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/dashboard.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,mGAAmG;EACnG,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6GAA6G;EAC7G,WAAW;EACX,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;EAEE;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,mBAAmB;EACrB;AACF","sourcesContent":["/* Base Styles */\n.customSidebar {\n  background: linear-gradient(175deg, var(--secondary) 0%, var(--secondary) 30%, var(--primary) 100%);\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n  z-index: 9999;\n  overflow-y: auto;\n  min-width: 200px;\n  max-width: 300px;\n}\n\n.customSidebar.active {\n  transform: translateX(0%);\n}\n\n.customSidebar .sidebarHead {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n}\n\n.customSidebar .sidebarHead img {\n  height: 40px;\n  width: 100%;\n  object-fit: contain;\n}\n\n.customSidebar hr {\n  background-image: linear-gradient(90deg, rgba(46, 46, 144, 0) 0%, white 49.72%, rgba(46, 46, 144, 0) 101.55%);\n  height: 1px;\n  opacity: 1;\n  border: 0;\n  margin: 0;\n}\n\n/* Sidebar Menu */\n.sidebarMenu {\n  margin-top: 70px;\n  height: 65vh;\n  overflow-y: scroll;\n}\n\n.sidebarMenu::-webkit-scrollbar {\n  width: 0;\n}\n\n.menuItem {\n  position: relative;\n  z-index: 99;\n}\n\n.menuItem a,\n.sidebarAccordion .menuItem button {\n  padding: 10px 0 10px 30px;\n  margin-bottom: 10px;\n  color: white;\n  font-weight: 600;\n  display: block;\n  text-decoration: none;\n  font-size: 16px;\n  transition: color 0.5s ease;\n}\n\n.menuItem a svg,\n.sidebarAccordion .menuItem button svg {\n  font-size: 16px;\n}\n\n.menuItem::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: -1px;\n  width: 0;\n  height: 100%;\n  background-color: white;\n  border-radius: 15px 0 0 15px;\n  z-index: -1;\n  transition: width 0.5s ease;\n}\n\n.menuItem.active::before,\n.menuItem:hover::before {\n  width: 100%;\n}\n\n.menuItem.active a,\n.sidebarAccordion .menuItem.active button,\n.menuItem:hover a,\n.sidebarAccordion .menuItem:hover button {\n  color: var(--primary);\n}\n\n/* Sidebar Footer */\n.sidebarFooter {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n\n.sidebarFooter span {\n  text-align: center;\n  padding: 15px;\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  display: block;\n}\n\n.sidebarFooter button {\n  line-height: 30px;\n  color: white !important;\n  font-weight: 600;\n  font-size: 16px;\n  padding-bottom: 15px;\n  border: 0;\n}\n\n.sidebarFooter button svg {\n  font-size: 16px;\n}\n\n/* Toggle Buttons */\n.sidebarToggleWrap {\n  display: none;\n}\n\n.sidebarToggleBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  border-radius: 50%;\n  background: #fff;\n  color: var(--primary);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 2px 10px rgba(46, 46, 144, 0.15);\n  flex-shrink: 0;\n}\n\n.sidebarClose {\n  display: none;\n  cursor: pointer;\n  border: 0;\n  background: white;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  padding: 10px;\n  border-radius: 50%;\n  z-index: 10001;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Accordion */\n.sidebarSubMenu ul {\n  list-style: none;\n  padding: 0;\n}\n\n.submenuDropdownIcon svg {\n  font-size: 24px !important;\n  transition: transform 0.5s ease;\n}\n\n.sidebarAccordion .menuItem {\n  background: none;\n  border: 0;\n}\n\n.sidebarAccordion .menuItem button {\n  background: none;\n  box-shadow: none;\n  border: none;\n}\n\n.sidebarAccordion .menuItem button[aria-expanded='true'] .submenuDropdownIcon svg {\n  transform: rotate(180deg);\n}\n\n.sidebarAccordion .menuItem button::after {\n  display: none !important;\n}\n\n.sidebarAccordion .menuItem:has(h2 button[aria-expanded='true']) {\n  border-radius: 15px 0 0 15px;\n  background-color: white;\n}\n\n.sidebarAccordion .menuItem:has(h2 button[aria-expanded='true']) button,\n.sidebarAccordion .menuItem:has(h2 button[aria-expanded='true']) a {\n  color: #2E2E90;\n}\n\n/* Main Content Wrapper */\n.sidebarContentWrapper {\n  background-color: white;\n  height: 100vh;\n  width: 100%;\n  overflow-y: auto;\n  position: relative;\n}\n\n.customBackdrop::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  z-index: 9998;\n}\n\n/* Body No Scroll */\nbody.no-scroll {\n  overflow: hidden;\n}\n\n/* Mobile Content */\n.mobileContentWrapper {\n  min-height: 100vh;\n  position: relative;\n  background-color: white;\n}\n\n.mobileContent {\n  padding: 15px;\n}\n\n.mobileMenu {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 0;\n}\n\n.mobileMenu ul {\n  display: flex;\n  justify-content: space-around;\n  padding: 0;\n  list-style: none;\n  margin: 0;\n  background-color: white;\n  box-shadow: 10px 8px 10px 5px var(--primary);\n  border-radius: 3px 3px 0 0;\n}\n\n.mobileMenu ul li {\n  color: var(--primary);\n  font-size: 24px;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  padding: 10px 0;\n}\n\n.mobileMenu ul li.active {\n  box-shadow: 0 0 5px var(--primary);\n  font-size: 28px;\n  background-color: var(--primary);\n  color: white;\n  padding: 12px 0;\n}\n\n/* Media Queries */\n@media (max-width: 1399px) {\n\n  .menuItem a,\n  .sidebarFooter button svg,\n  .sidebarFooter button,\n  .menuItem a svg,\n  .sidebarAccordion .menuItem button,\n  .sidebarAccordion .menuItem button svg {\n    font-size: 14px;\n  }\n\n  .sidebarFooter span {\n    font-size: 12px;\n  }\n\n  .customSidebar .sidebarHead img {\n    height: 35px;\n  }\n\n  .menuItem a,\n  .sidebarAccordion .menuItem button {\n    padding: 10px 0 10px 20px;\n  }\n}\n\n@media (max-width: 1024px) {\n\n  .menuItem a,\n  .sidebarFooter button svg,\n  .sidebarFooter button,\n  .menuItem a svg,\n  .sidebarAccordion .menuItem button,\n  .sidebarAccordion .menuItem button svg {\n    font-size: 12px;\n  }\n\n  .sidebarFooter span {\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 991px) {\n  .customSidebar {\n    width: 0;\n    min-width: 0;\n    max-width: none;\n  }\n\n  .customSidebar.active {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .sidebarToggleWrap {\n    display: block;\n    padding: 12px 0 8px;\n  }\n\n  .sidebarClose {\n    display: inline-flex;\n  }\n\n  .sidebarContentWrapper {\n    width: 100%;\n  }\n\n  .menuItem a,\n  .sidebarFooter button,\n  .sidebarFooter span,\n  .sidebarAccordion .menuItem button {\n    white-space: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customSidebar": `dashboard_customSidebar__lrdY8`,
	"active": `dashboard_active__UkmNb`,
	"sidebarHead": `dashboard_sidebarHead__GObQC`,
	"sidebarMenu": `dashboard_sidebarMenu__CD2jt`,
	"menuItem": `dashboard_menuItem__8+HgP`,
	"sidebarAccordion": `dashboard_sidebarAccordion__18JkA`,
	"sidebarFooter": `dashboard_sidebarFooter__WbIrB`,
	"sidebarToggleWrap": `dashboard_sidebarToggleWrap__Aja58`,
	"sidebarToggleBtn": `dashboard_sidebarToggleBtn__IgSrx`,
	"sidebarClose": `dashboard_sidebarClose__eUuZq`,
	"sidebarSubMenu": `dashboard_sidebarSubMenu__o-YgG`,
	"submenuDropdownIcon": `dashboard_submenuDropdownIcon__KcK0Z`,
	"sidebarContentWrapper": `dashboard_sidebarContentWrapper__aYsOZ`,
	"customBackdrop": `dashboard_customBackdrop__hkYdg`,
	"no-scroll": `dashboard_no-scroll__oXT-Z`,
	"mobileContentWrapper": `dashboard_mobileContentWrapper__gsf-4`,
	"mobileContent": `dashboard_mobileContent__g39VN`,
	"mobileMenu": `dashboard_mobileMenu__90XAP`
};
export default ___CSS_LOADER_EXPORT___;
